const Diacritics = require('diacritic');
const { mustDeleteTypeRoad, getLengthNameOfRoad } = require('utilities/logicByCountry');

function sanitizeName(list, value) {
    let search = value.toLowerCase();
    if (search === 'illes balears') {
        search = 'baleares';
    }

    const search2 = Diacritics.clean(search);

    const result = list.find(item => item.label.toLowerCase() === search || item.label.toLowerCase() === search2);
    return result;
}

function SuggestionParser(provinces, roads, suggestions) {
    const result = suggestions
        .map(x => {
            x.target = x.types[0];
            return x;
        })
        .reduce((acc, item) => {
            switch (item.target) {
                case 'country':
                    acc.country = item.short_name;
                    break;
                case 'administrative_area_level_1':
                    acc.administrative_area_level_1 = item.short_name;
                    break;
                case 'administrative_area_level_2': {
                    const sanitizedShortName = sanitizeName(provinces, item.short_name);
                    const sanitizedLongName = sanitizeName(provinces, item.long_name);
                    if (sanitizedShortName || sanitizedLongName) {
                        acc.administrative_area_level_2 =
                            (sanitizedShortName && sanitizedShortName.value) ||
                            (sanitizedLongName && sanitizedLongName.value);
                    }
                    break;
                }
                case 'street_number': {
                    if (!item.long_name.includes('-')) {
                        acc.street_number = item.long_name;
                    }
                    break;
                }
                case 'locality': {
                    acc.locality = item.long_name;
                    acc.town = item.long_name;
                    break;
                }
                case 'postal_code':
                    acc.postal_code = item.long_name;
                    break;
                case 'route': {
                    const typeOfRoad = item.long_name.split(' ')[0];
                    acc.route = item.long_name;

                    if (mustDeleteTypeRoad()) {
                        const route = item.long_name.replace(typeOfRoad, '');
                        if (typeOfRoad != item.long_name) {
                            acc.route = route.length && route[0] == ' ' ? route.slice(1) : route;
                        }
                    }

                    const maxLength = getLengthNameOfRoad();
                    if (acc.route.length > maxLength) {
                        acc.route = acc.route.substring(0, maxLength);
                    }

                    const sanitizedShortRoute = sanitizeName(roads, typeOfRoad);
                    const sanitizedLongRoute = sanitizeName(roads, item.long_name);

                    if (sanitizedShortRoute || sanitizedLongRoute) {
                        acc.type_of_road =
                            (sanitizedShortRoute && sanitizedShortRoute.value) ||
                            (sanitizedLongRoute && sanitizedLongRoute.value);
                    }

                    break;
                }
                default:
                    break;
            }
            return acc;
        }, {});

    if (
        result.hasOwnProperty('town') &&
        (result.town.toLowerCase() === 'ceuta' || result.town.toLowerCase() === 'melilla')
    ) {
        const sanitizedName = sanitizeName(provinces, result.town);
        if (sanitizedName) {
            result.administrative_area_level_2 = sanitizedName.value;
        }
    }

    return result;
}

module.exports = SuggestionParser;

/*
Sample suggestion returned by GeoSuggest
{
   "results" : [
      {
         "address_components" : [
            {
               "long_name" : "Carrer de Balmes",
               "short_name" : "Carrer de Balmes",
               "types" : [ "route" ]
            },
            {
               "long_name" : "Barcelona",
               "short_name" : "Barcelona",
               "types" : [ "locality", "political" ]
            },
            {
               "long_name" : "Barcelona",
               "short_name" : "Barcelona",
               "types" : [ "administrative_area_level_2", "political" ]
            },
            {
               "long_name" : "Catalunya",
               "short_name" : "CT",
               "types" : [ "administrative_area_level_1", "political" ]
            },
            {
               "long_name" : "Spain",
               "short_name" : "ES",
               "types" : [ "country", "political" ]
            }
         ],
         "formatted_address" : "Carrer de Balmes, Barcelona, Spain",
         "geometry" : {
            "bounds" : {
               "northeast" : {
                  "lat" : 41.4102423,
                  "lng" : 2.1673975
               },
               "southwest" : {
                  "lat" : 41.3857133,
                  "lng" : 2.13646
               }
            },
            "location" : {
               "lat" : 41.3977969,
               "lng" : 2.1517067
            },
            "location_type" : "GEOMETRIC_CENTER",
            "viewport" : {
               "northeast" : {
                  "lat" : 41.4102423,
                  "lng" : 2.1673975
               },
               "southwest" : {
                  "lat" : 41.3857133,
                  "lng" : 2.13646
               }
            }
         },
         "place_id" : "ChIJ2xqFoJmipBIRKE6vTH-Eyv4",
         "types" : [ "route" ]
      }
   ],
   "status" : "OK"
}

*/
